import { Button, Col, Form, ListGroup, Row } from 'react-bootstrap';
import { useState, useRef } from 'react';
import { useOutletContext } from 'react-router';
import { useGetStandardsListMutation } from '../../../../../features/authentication/standardApiSlice';
import { faMagnifyingGlass, faCircleXmark as lightXmark } from '@fortawesome/pro-light-svg-icons';
import { faCircleXmark as solidXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuestionSearchContext } from '../context';
import HesSpinner from '../../../../../components/loadingOverlay/hesSpinner';
import { faListTree } from '@fortawesome/pro-duotone-svg-icons';
import StandardTreeModal from './StandardTreeModel';
import { faCircleMinus, faCirclePlus, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const Standards = () => {
  const [selectedStandardNodes, setSelectedStandardNodes] = useState([]);
  const [standardsList, setStandardsList] = useState([]);
  const outletContext = useOutletContext();
  const [searchStandards] = useGetStandardsListMutation();
  const [searchHasFocus, setSearchHasFocus] = useState(false);
  const standardRef = useRef();
  const [clearHover, setClearHover] = useState(false);
  const questionSearchContext = useQuestionSearchContext();
  const [openStandardTreeModal, setOpenStandardTreeModal] = useState(false);
  const [isExpand, setIsExpand] = useState(false);

  const SearchQuestions = () => {
    var standardNodes = selectedStandardNodes.filter(key => isNaN(Number(key)));
    const params = new URLSearchParams();
    standardNodes.forEach(item => params.append('standards', item));
    var searchRequest = {
      keyword: params.toString()
    };
    outletContext.initalizeStandardsSearch(searchRequest);
    setIsExpand(false);
  };

  const handleStandardSelect = (key) => {
    if(!selectedStandardNodes.includes(key))
      setSelectedStandardNodes((prevData) => {
        return [...prevData, key];
      });
  };

  const handleStandardsSearch = (e) => {
    if (e.target.value <= 0) {
      setStandardsList([]);
      return;
    }
    searchStandards(e.target.value).then((result) => {
      if (!result?.data) return;
      setStandardsList(result.data);
    });
  };

  const handleClearSearch = () => {
    standardRef.current.value = '';
    setStandardsList([]);
    standardRef.current.focus();
    setSearchHasFocus(true);
  };

  const removeChips = (removeId) => {
    if (removeId == 'clear')
      setSelectedStandardNodes([]);
    else {
      const filteredChips = selectedStandardNodes.filter(item => item != removeId);
      setSelectedStandardNodes(filteredChips);
    }
  };

  const handleOnClose = () => {
    setOpenStandardTreeModal(false);
    setIsExpand(true);
  };

  return (
    <>
      <div className='castleQuestionsSearchBox'>
        <div className='d-flex flex-row align-items-center gap-2'>
          {outletContext.courseFilters.isError && <div className='d-flex w-100 justify-content-center align-items-center'>
            <button style={{ color: '#F84646', fontSize: '1.15rem', border: 'none', background: 'none' }} onClick={() => outletContext.fetchCourseFilters()}>There was an error getting your courses. Click to try again</button>
          </div>}

          {outletContext.courseFilters.isLoading && <div className='d-flex flex-row w-100 justify-content-center align-items-center'>
            <HesSpinner width='2%' />
            <span style={{ fontSize: '2em' }} className='ms-2'>Getting your standards...</span>
          </div>}
          <Row className='w-100'>
            {!outletContext.courseFilters.isError && !outletContext.courseFilters.isLoading &&
              <Col className='col-6 d-flex gap-3'><ListGroup.Item className='mx-1'>
                <Form.Group id="standardSearchGroup">
                  <div>
                    <Form.Control style={{ paddingLeft: '35px', paddingRight: '35px' }} type='text' placeholder='Standard' ref={standardRef}
                      onChange={(e) => handleStandardsSearch(e)}
                      onFocus={() => setSearchHasFocus(true)}
                      onKeyUp={(e) => { if (selectedStandardNodes?.length > 0 && e.key == 'Enter') SearchQuestions(); }} />
                    <FontAwesomeIcon className='searchIcon' icon={faMagnifyingGlass} />
                    <FontAwesomeIcon className={`clearSearchIcon ${standardRef.current?.value?.length > 0 ? '' : 'd-none'}`}
                      icon={clearHover ? solidXmark : lightXmark}
                      onMouseEnter={() => setClearHover(true)}
                      onMouseLeave={() => setClearHover(false)}
                      onClick={() => handleClearSearch()} />
                    {searchHasFocus && standardsList.length > 0 && <ul className='standardList'>
                      {standardsList && standardsList.map((item, index) => (
                        <li key={`standard_${index}`} onClick={() => { handleStandardSelect(item); setSearchHasFocus(false); }}>{item}</li>
                      ))}
                    </ul>}
                  </div>
                </Form.Group>
              </ListGroup.Item>
              <Button variant='castleWhite btn-width' disabled={questionSearchContext.isSearching || selectedStandardNodes?.length <= 0} onClick={() => SearchQuestions()}>Search</Button>
              </Col>}
            <Col className='col-3 p-3 cursor-pointer' onClick={() => setOpenStandardTreeModal(true)}>
              <FontAwesomeIcon className='mx-2' icon={faListTree} />
              <label className='text-orange cursor-pointer'>Browse Standards Tree</label>
            </Col>
          </Row>
        </div>
        {selectedStandardNodes?.filter(key => isNaN(Number(key))).length > 0 &&
          <>
            <div className='d-flex mt-3 text-orange cursor-pointer w-fitcontent' onClick={() => setIsExpand(!isExpand)}>
              <div className=''>Selected Standards</div>
              <FontAwesomeIcon className='mx-2 mt-1' icon={isExpand ? faCircleMinus : faCirclePlus} />
            </div>
            {isExpand &&
               <div className='castleQuestionsSearchBox mt-3'>
                 <div className='text-orange mb-3 text-end'>
                   <label className='cursor-pointer' onClick={() => removeChips('clear')}>Clear All</label>
                 </div>
                 <div className="form-chips d-flex align-items-center gap-2 flex-wrap overflow-auto">
                   {selectedStandardNodes.filter(key => isNaN(Number(key))).map((item) => (
                     <span key={item}>
                       {item}
                       <FontAwesomeIcon
                         icon={faTimesCircle}
                         className="ms-1 cursor-pointer text-danger"
                         id={`chip-${item}`}
                         onClick={() => removeChips(item)}
                       />
                     </span>
                   ))}
                 </div>
               </div>
            }
          </>
        }
      </div>
      {openStandardTreeModal &&
        <StandardTreeModal
          isOpen={openStandardTreeModal}
          onClose={handleOnClose}
          selectedStandardNodes={selectedStandardNodes}
          setSelectedStandardNodes={setSelectedStandardNodes}
        />
      }
    </>
  );
};

export default Standards;
